import { ComponentProps, useCallback, useContext } from 'react';
import { ButtonWithIcon } from 'src/components/Buttons';
import { useActivePosEntityContext } from 'src/contexts/ActivePosEntityContext';
import { ModalContext } from 'src/contexts/ModalContext';
import { vars } from 'src/core/themes';
import { RetailSale } from 'src/modals/RetailSale';
import { CartOutlineIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import {
  ActionOutboxEntityType,
  ListingDetailDataField,
  ListingDetails,
} from 'src/WebApiController';

type LaunchCreateRetailSaleProps = Omit<
  ComponentProps<typeof ButtonWithIcon>,
  'onClick' | 'textContentId' | 'icon' | 'iconProps'
> & {
  listingId: number;
  marketplaceListingId?: string | null;
};

export const LaunchCreateRetailSale = ({
  listingId,
  marketplaceListingId,
  variant,
  ...buttonProps
}: LaunchCreateRetailSaleProps) => {
  const { setModal } = useContext(ModalContext);
  const { setActivePosEntity } = useActivePosEntityContext<ListingDetails>();

  const onLaunchDialog = useCallback(
    (e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();

      setActivePosEntity(listingId, marketplaceListingId, true, [
        ListingDetailDataField.Basic,
        ListingDetailDataField.Tickets,
      ]);
      setModal({
        children: <RetailSale />,
        clickOutsideToClose: true,
        size: 'slide-in',
        deepLinkValue: listingId,
        trackViewEntityType: ActionOutboxEntityType.Listing,
      });
    },
    [setModal, setActivePosEntity, listingId, marketplaceListingId]
  );

  return (
    <ButtonWithIcon
      {...buttonProps}
      icon={<CartOutlineIcon withHoverEffect size={vars.iconSize.l} />}
      onClick={onLaunchDialog}
      textContentId={ContentId.AddRetailSale}
      variant={variant}
      justifyContent="space-between"
      textColor={variant === 'textPlain' ? 'strong' : 'brand'}
      style={variant === 'textPlain' ? { width: '100%' } : undefined}
    />
  );
};
